import React from 'react';

const SectionLabel = ({ icon: Icon, children }) => (
  <div className="inline-flex items-center gap-2 text-[11px] font-mono tracking-[0.22em] text-orange-300 uppercase">
    {Icon && <Icon className="w-3.5 h-3.5" />}
    {children}
  </div>
);

export default SectionLabel;
